<template>
  <div>
    <page-toolbar :searchable="false">
      <template #filters>
        <v-col cols="auto" v-if="childrenCompanies.length > 0 && !company?.parent_id">
          <autocomplete
            :value="companyChildren"
            @input="$emit('update:companyChildren', $event)"
            @change="$emit('company-filter-changed')"
            :items="childrenCompaniesTranslated"
            select-all
            multiple
            color="white"
            item-text="name"
            item-value="id"
            :label="$t('select_company')"
            icon="mdi-office-building"
            clearable
            chips
            small-chips
            deletable-chips
            style="width: 400px"
            hide-details
            prepend-item
          >
          </autocomplete>
        </v-col>
        <v-col cols="auto">
          <text-field
            kind="search"
            v-model="model"
            color="white"
            hide-details
            :label="$t('search_users_placeholder')"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn-toggle
            :value="statusFilter"
            @change="$emit('update:statusFilter', $event || 'all')"
            mandatory
            color="primary"
            class="mt-6 btn-toggle-active-employees"
          >
            <v-btn value="all" height="40px" class="text-initial">{{ $t("all") }}</v-btn>
            <v-btn value="active" height="40px">{{ $t("active") }}</v-btn>
            <v-btn value="inactive" height="40px">{{ $t("inactive") }}</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col align="end">
          <v-row no-gutters justify="end">
            <div>
              <v-row no-gutters class="toolbar-actions">
                <circle-button
                  icon="mdi-account-plus"
                  @click="$emit('add-employee')"
                  color="primary"
                  :small="false"
                  :tooltip="$t('add_worker')"
                />

                <circle-button
                  icon="mdi-account-multiple-plus"
                  @click="$emit('add-multiple-employees')"
                  :small="false"
                  color="green"
                  :tooltip="$t('add_multiple_users')"
                ></circle-button>

                <circle-button
                  v-if="hasPermission && !isDeliveryUsersContext"
                  icon="mdi-file-excel"
                  @click="$emit('import-excel')"
                  :small="false"
                  color="success"
                  :tooltip="$t('import_excel')"
                ></circle-button>

                <employee-button-print
                  :employees="visibleEmployees"
                  :headers="headersForPrint"
                  :title="toLatin(restaurantName) || ''"
                  :subtitle="toLatin(parentCompany?.name) || ''"
                  class="toolbar-btn"
                  :bigger-button="false"
                />
                <circle-button
                  v-if="user.type == 'admin'"
                  icon="mdi-account-search"
                  @click="$emit('search-user')"
                  color="warning"
                  :small="false"
                  :tooltip="$t('search_by_id')"
                ></circle-button>

                <circle-button
                  :small="false"
                  :to="{
                    name: 'firma-id-qrlist',
                    params: { id: companyId },
                  }"
                  icon="mdi-qrcode"
                  :label="$t('qr_codes')"
                ></circle-button>
              </v-row>
            </div>
          </v-row>
        </v-col>
      </template>
    </page-toolbar>
  </div>
</template>

<script>
import EmployeeButtonPrint from "./buttons/EmployeeButtonPrint.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";
import hasModel from "@/mixins/hasModel";
import deliveryUsersContext from "@/mixins/deliveryUsersContext";

export default {
  mixins: [hasModel, deliveryUsersContext],
  name: "EmployeeToolbar",
  components: {
    EmployeeButtonPrint,
    PageToolbar,
  },
  props: {
    restaurantName: {
      type: String,
      default: "",
    },
    companyChildren: {
      type: Array,
      default: () => [],
    },
    childrenCompanies: {
      type: Array,
      default: () => [],
    },
    company: {
      type: Object,
      default: null,
    },
    visibleEmployees: {
      type: Array,
      default: () => [],
    },
    parentCompany: {
      type: Object,
      default: null,
    },
    showCreditColumn: {
      type: Boolean,
      default: false,
    },
    statusFilter: {
      type: String,
      default: "all",
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companyId() {
      return this.$route.params.id || this.$store.state.company.id;
    },
    childrenCompaniesTranslated() {
      return this.childrenCompanies.map((company) => ({
        ...company,
        name: this.toLatin(company.name),
      }));
    },
    hasPermission() {
      if (this.user.user_menu) {
        let permission = JSON.parse(this.user.user_menu.menu1);
        return (
          this.user.type === "admin" || permission.some((i) => i.title === "impor_user")
        );
      }
      return false;
    },
    // Compute headers for print based on current state
    headersForPrint() {
      const headers = [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: this.$t("external_code"),
          align: "start",
          value: "external_code",
        },
        {
          text: this.$t("name"),
          align: "start",
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("last_name"),
          align: "start",
          value: "lastname",
          sortable: true,
        },
        {
          text: this.$t("email"),
          align: "start",
          value: "email",
          sortable: true,
        },
        {
          text: this.$t("role"),
          align: "start",
          value: "type",
          sortable: true,
        },
        {
          text: this.$t("status"),
          align: "start",
          value: "state",
          sortable: true,
        },
      ];

      // Add credit column if needed
      if (this.showCreditColumn) {
        headers.push({
          text: "credit_only",
          align: "start",
          value: "credit",
          sortable: true,
        });
      }

      return headers;
    },
  },
};
</script>

<style>
.btn-toggle-active-employees .v-btn {
  text-transform: none;
}
</style>
